export default __webpack_public_path__ + "static/media/fehlstellung-des-zahns.7a7c0663.png";